module.exports = __webpack_public_path__ + "static/media/myClassroom.51094530.svg";